import da_DK from "./da-DK.json";
import en_AU from "./en-AU.json";
import en_GB from "./en-GB.json";
import en_US from "./en-US.json";
import fi_FI from "./fi-FI.json";
import no_NO from "./no-NO.json";
import sv_SE from "./sv-SE.json";

export default {
  da_DK: { translation: da_DK },
  en_AU: { translation: en_AU },
  en_GB: { translation: en_GB },
  en_US: { translation: en_US },
  fi_FI: { translation: fi_FI },
  no_NO: { translation: no_NO },
  sv_SE: { translation: sv_SE }
};
